import React, { Component } from "react";
import outside from "../../../../media/reduced-images/outside-straight.jpg";
import Helmet from "react-helmet";

import styles from "./AboutUs.module.scss";

class AboutUs extends Component {
  render() {
    const headerImageProps = {
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundImage: `url(${outside})`
    };

    return (
      <div id={styles.container}>
        <Helmet>
          <title>About Us</title>
          <meta
            name="description"
            content=" Why Powder Solutions was founded and more about our business
            philosophy."
          />
        </Helmet>
        <div id={styles.titleImage} style={headerImageProps}>
          <div id={styles.titleText}>About Our Company</div>
        </div>
        <div id={styles.founderTextContainer}>
          <div id={styles.founderText}>
            In 1999, I founded Powder Solutions to provide quality pulverizing
            and screening services. I felt that providing exceptional customer
            service was as equally important to expert processing. Ultimately, I
            wanted our customers to feel as if we are a seamless extension to
            the manufacturing process of their products.
            <br />
            <br />
            We will work with you to fit your scheduling needs from raw material
            and supply receipts to final shipping. Our QC department can tailor
            Certificates of Analysis to your specific customers. I believe that
            helping to make your business successful is what makes our business
            successful.
            <br />
            <br />
            -Michael S. Austin
            <br /> <br />
            President
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUs;
